import { render } from "./LogoSvg.vue?vue&type=template&id=94a24590"
import script from "./LogoSvg.vue?vue&type=script&lang=js"
export * from "./LogoSvg.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./LogoSvg.vue?vue&type=style&index=0&id=94a24590&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__